import Vue from 'vue'
import Vuex from 'vuex'
import loginApi from '@/request/api-manager/login'
import {
  REDIRECT_URL
} from "@/store/mutation-types";

Vue.use(Vuex);

const state = {
  token: localStorage.token,
  sessionId: localStorage.sessionId,
  userId: 0,
  userName: localStorage.userName,
  undoList: [],
  redoList: []
}

const getters = {
  getUndoList() {
    return state.undoList
  },
  getRedoList() {
    return state.redoList
  },
  getToken() {
    return state.token
  },
  getSessionId() {
    return state.sessionId
  },
  getUserId() {
    return state.userId
  },
  getUserName() {
    return state.userName
  }
}

const mutations = {
  setUndoList(state, undoList) {
    state.undoList = undoList
  },
  setRedoList(state, redoList) {
    state.redoList = redoList
  },
  saveToken(state, token) {
    state.token = token
  },
  saveSessionId(state, sessionId) {
    state.sessionId = sessionId
  },
  saveUserId(state, userId) {
    state.userId = userId
  },
  saveUserName(state, userName) {
    state.userName = userName
  },
}

const actions = {
  changeToken(context, data) {
    context.commit('saveToken', data);
  },
  changeSessionId(context, data) {
    context.commit('saveSessionId', data);
  },
  changeUserId(context, data) {
    context.commit('saveUserId', data);
  },
  changeUserName(context, data) {
    context.commit('saveUserName', data);
  },
  // 登出
  Logout({
    commit,
    state
  }) {
    return new Promise((resolve) => {
      let logoutToken = state.token;
      commit('saveToken', '')
      commit('saveUserId', '')
      let redirect = encodeURIComponent(Vue.ls.get(REDIRECT_URL));
      window.location.href = '/login' + (redirect ? `?redirect=${redirect}` : '')
      Vue.ls.clear()
      //console.log('logoutToken: '+ logoutToken)
      loginApi.logout(logoutToken).then(() => {
        // resetRouter()
        resolve()
      }).catch(() => {
        resolve()
      })
    })
  },

}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});

export default store;